import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";

// import { GATAdminState } from "../store/gat-admin-slice-types";

const useGatAdminConfigData = () => {
	const companyDataValue = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.companyData
	);
	const companyLocationClustersValue = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.companyLocationClusters
	);
	const companySettingsValue = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.companySettings
	);
	const getCompanyLocationClustersStatus = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.getCompanyLocationClusters.status
	);
	const locations = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.locations
	);

	const companySettingsObj = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.companySettings
	);

	const getCompanySettingsStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getCompanySettings.status
	);
	const getCompanySettingsErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getCompanySettings.errorMessage
	);

	const getCompanyDataStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getCompanyData.status
	);
	const getCompanyDataErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getCompanyData.errorMessage
	);

	const updateCompanyDataStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateCompanyData.status
	);
	const updateCompanyDataErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateCompanyData.errorMessage
	);

	const updateCompanySettingsStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateCompanySettings.status
	);
	const updateCompanySettingsErrorMessage = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateCompanySettings.errorMessage
	);

	const updateCompanySettingsLevelStatus = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateCompanySettingsLevel.status
	);
	const updateCompanySettingsLevelErrorMessage = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateCompanySettingsLevel.errorMessage
	);

	const createNewCompanyStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewCompany.status
	);
	const createNewCompanyErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewCompany.errorMessage
	);

	const createCompanyUserStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createCompanyUser.status
	);
	const createCompanyUserErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createCompanyUser.errorMessage
	);
	const updateCompanyUserStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateCompanyUser.status
	);
	const updateCompanyUserErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateCompanyUser.errorMessage
	);

	const updateLocationStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateLocationData.status
	);
	const updateLocationErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateLocationData.errorMessage
	);

	const createNewLocationStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewLocation.status
	);
	const createNewLocationErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewLocation.errorMessage
	);

	const newLocationId = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewLocation.locationId
	);

	const createNewWorkCenterStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewWorkCenter.status
	);
	const updateWorkCenterStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateWorkCenterData.status
	);
	const createNewWorkCenterErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewWorkCenter.errorMessage
	);
	const updateWorkCenterErrorMessage = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateWorkCenterData.errorMessage
	);

	const updateLocationDataStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateLocationData.status
	);
	const openLocationDialog = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.openLocationDialog
	);

	const allocationTypes = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.getAllShiftAllocationRules.allocationTypes
	);

	const locationSettingsObj = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.locationSettings
	);

	const getLocationsStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getLocations.status
	);
	const getLocationDataStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getLocations.status
	);
	const getLocationsErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getLocations.errorMessage
	);

	const creatingNewCompany = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.creatingNewCompany
	);

	const creatingNewLocation = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.creatingNewLocation
	);

	const newCompanyId = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createNewCompany.newCompanyId
	);

	const timeZones = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.timeZones
	);

	const currentLocationData = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.currentLocationData
	);

	const currentCompanyData = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.currentCompanyData
	);

	const companyId = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.currentCompanyData.id
	);

	const allSettings = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.allSettingTypes
	);

	const shiftAllocationTypes = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getAllShiftAllocationRules
	);

	const locationsShiftRules = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.locations
	);

	const allJobsByLocation = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getAllJobsByLocation.jobs
	);

	const allJobsByLocationObject = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getAllJobsByLocation.jobsObject
	);

	const createNewCompanyUserStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createCompanyUser.status
	);

	const openCompanyUserDialog = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.openCompanyUserDialog
	);
	const allCompanyUserRoles = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.allCompanyUserRoles
	);
	const allCompanyWorkCenters = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.allCompanyWorkCenters
	);

	const workerNotifyCats = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getWorkerNotificationTypes.data
	);

	const getLocationSettingsStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getLocationSettings.status
	);

	const locationId = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.currentLocationData.id
	);

	const getLeaveTypesStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getLeaveTypes.status
	);

	const getLeaveTypesErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getLeaveTypes.errorMessage
	);

	const getLeaveTypesData = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getLeaveTypes.data
	);

	const createTimeOffTypeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createTimeOffType.status
	);

	const createTimeOffTypeErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createTimeOffType.errorMessage
	);

	const editTimeOffTypeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.editTimeOffType.status
	);

	const editTimeOffTypeErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.editTimeOffType.errorMessage
	);

	const saveSkillPrioritiesStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.saveSkillPriorities.status
	);

	const saveSkillPrioritiesErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.saveSkillPriorities.errorMessage
	);

	const deleteTimeOffTypeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.deleteTimeOffType.status
	);

	const deleteTimeOffTypeErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.deleteTimeOffType.errorMessage
	);

	const shiftPurposesData = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getShiftPurposes.data
	);

	const getShiftPurposesStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getShiftPurposes.status
	);

	const createShiftPurposeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createShiftPurpose.status
	);

	const createShiftPurposeErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.createShiftPurpose.errorMessage
	);

	const editShiftPurposeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.editShiftPurpose.status
	);

	const editShiftPurposeErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.editShiftPurpose.errorMessage
	);

	const deleteShiftPurposeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.deleteShiftPurpose.status
	);

	const deleteShiftPurposeErrorMessage = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.deleteShiftPurpose.errorMessage
	);

	const updateShiftPurposeStatusStatus = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateShiftPurposeStatus.status
	);

	const updateShiftPurposeStatusErrorMessage = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateShiftPurposeStatus.errorMessage
	);

	const companyNotAssignedSkillLevel = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.companyNotAssignedSkillLevel
	);

	const workerTypes = useSelector(
		(state: StoreType) => state.manageWorkers.workerTypes
	);

	const workerSubTypes = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getWorkerSubType.data
	);

	const getWorkerSubTypeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.getWorkerSubType.status
	);

	const addWorkerSubTypeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.addWorkerSubType.status
	);

	const editWorkerSubTypeStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.editWorkerSubType.status
	);

	const updateWorkerTypeHoursStatus = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.updateWorkerTypeHours.status
	);

	const updateAllowedWorkCentersForShiftsStatus = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateAllowedWorkCentersForShifts.status
	);

	const minShiftDurationHours = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.currentCompanyData.minShiftDuration
	);

	const maxShiftDurationHours = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.currentCompanyData.maxShiftDuration
	);

	const fullTimeSchedulingLocationSettings = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.getCompanyFullTimeScheduleLocationSettings
				.locationSettings
	);

	const fullTimeSchedulingLocationSettingsStatus = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.getCompanyFullTimeScheduleLocationSettings
				.status
	);

	const fullTimeScheduleSelectedLocations = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateCompanyFullTimeScheduleLocationSettings
				.selectedLocations
	);

	const absenceManagementLocationSettings = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.getCompanyAbsenceManagementLocationSettings
				.locationSettings
	);

	const absenceManagementSelectedLocations = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.updateCompanyAbsenceManagementLocationSettings
				.selectedLocations
	);

	const absenceManagementLocationSettingsStatus = useSelector(
		(state: StoreType) =>
			state.gatAdminConfiguration.getCompanyAbsenceManagementLocationSettings
				.status
	);

	const shiftPatterns = useSelector(
		(state: StoreType) => state.gatAdminConfiguration.teams
	);

	return {
		locationId,
		getLocationSettingsStatus,
		shiftAllocationTypes,
		locationsShiftRules,
		allJobsByLocation,
		allJobsByLocationObject,
		allSettings,
		creatingNewCompany,
		creatingNewLocation,
		companySettingsObj,
		companyDataValue,
		companyLocationClustersValue,
		companySettingsValue,
		locations,
		allCompanyWorkCenters,
		getCompanySettingsStatus,
		getCompanySettingsErrorMessage,
		getCompanyDataStatus,
		getCompanyDataErrorMessage,
		updateCompanyDataStatus,
		updateCompanyDataErrorMessage,
		updateCompanySettingsStatus,
		updateCompanySettingsErrorMessage,
		createNewCompanyStatus,
		createNewCompanyErrorMessage,
		createCompanyUserStatus,
		createCompanyUserErrorMessage,
		updateCompanyUserStatus,
		updateCompanyUserErrorMessage,
		updateLocationStatus,
		updateLocationErrorMessage,
		createNewLocationStatus,
		createNewLocationErrorMessage,
		createNewWorkCenterStatus,
		createNewWorkCenterErrorMessage,
		updateWorkCenterStatus,
		updateWorkCenterErrorMessage,
		updateLocationDataStatus,
		openLocationDialog,
		allocationTypes,
		locationSettingsObj,
		getLocationsStatus,
		getLocationDataStatus,
		getLocationsErrorMessage,
		updateCompanySettingsLevelStatus,
		updateCompanySettingsLevelErrorMessage,
		timeZones,
		newLocationId,
		newCompanyId,
		currentLocationData,
		getCompanyLocationClustersStatus,
		currentCompanyData,
		workerNotifyCats,
		createNewCompanyUserStatus,
		openCompanyUserDialog,
		allCompanyUserRoles,
		getLeaveTypesStatus,
		getLeaveTypesErrorMessage,
		getLeaveTypesData,
		createTimeOffTypeStatus,
		createTimeOffTypeErrorMessage,
		editTimeOffTypeStatus,
		editTimeOffTypeErrorMessage,
		saveSkillPrioritiesStatus,
		saveSkillPrioritiesErrorMessage,
		deleteTimeOffTypeStatus,
		deleteTimeOffTypeErrorMessage,
		shiftPurposesData,
		getShiftPurposesStatus,
		createShiftPurposeStatus,
		createShiftPurposeErrorMessage,
		editShiftPurposeStatus,
		editShiftPurposeErrorMessage,
		deleteShiftPurposeStatus,
		deleteShiftPurposeErrorMessage,
		updateShiftPurposeStatusStatus,
		updateShiftPurposeStatusErrorMessage,
		companyNotAssignedSkillLevel,
		workerSubTypes,
		getWorkerSubTypeStatus,
		companyId,
		workerTypes,
		addWorkerSubTypeStatus,
		editWorkerSubTypeStatus,
		updateWorkerTypeHoursStatus,
		updateAllowedWorkCentersForShiftsStatus,
		minShiftDurationHours,
		maxShiftDurationHours,
		fullTimeSchedulingLocationSettings,
		fullTimeSchedulingLocationSettingsStatus,
		fullTimeScheduleSelectedLocations,
		absenceManagementLocationSettings,
		absenceManagementSelectedLocations,
		absenceManagementLocationSettingsStatus,
		shiftPatterns,
	};
};

export default useGatAdminConfigData;
